import * as types from './types'

export const updateNavigationEditorAction = (data: types.INavigationEditor) => (
  (dispatch: Function) => {
    dispatch(updateNavigationEditor(data))
  }
)

const updateNavigationEditor = (data: types.INavigationEditor) => ({
  type: types.UPDATE_NAVIGATION_EDITOR,
  payload: data
})

export const updateStatusQuestionChangedAction = (data: boolean) => (
  (dispatch: Function) => {
    dispatch(updateStatusQuestionChanged(data))
  }
)

const updateStatusQuestionChanged = (data: boolean) => ({
  type: types.UPDATE_STATUS_QUESTION_CHANGE,
  payload: data
})
